function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      enableBackground: "new 0 0 22 32"
    },
    viewBox: "-1 -1 24 34"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21.2 4.9 9.8 15.6 22 27.1",
    style: {
      fill: "none",
      stroke: "#eca807",
      strokeWidth: 3
    }
  }));
};
export { SvgArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xIC0xIDI0IDM0IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAyMiAzMiI+PHBhdGggZD0iTTIxLjIgNC45TDkuOCAxNS42IDIyIDI3LjEiIHN0eWxlPSJmaWxsOm5vbmU7c3Ryb2tlOiNlY2E4MDc7c3Ryb2tlLXdpZHRoOjMiLz48L3N2Zz4K";